var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCreditNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.93259 19.4035H14.6561C17.32 19.4035 19.4792 17.2439 19.4792 14.5805V2.59646H9.75884C9.1192 2.59646 8.50576 2.85055 8.05347 3.30284C7.60118 3.75513 7.34709 4.36857 7.34709 5.00821L7.34388 7.34571",
    stroke: "#F8F8F8",
    strokeWidth: 0.458333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.52084 11.6375H7.34389M10.2836 11.6375H16.4074M10.2836 14.7478H16.4074M4.93259 7.34571H7.34389V16.9918C7.34364 17.6313 7.08953 18.2445 6.63739 18.6967C6.18525 19.149 5.57208 19.4032 4.93259 19.4035C4.29303 19.4033 3.67974 19.1491 3.2275 18.6969C2.77526 18.2446 2.52109 17.6314 2.52084 16.9918V9.757C2.52121 9.11752 2.77543 8.50434 3.22766 8.0522C3.67988 7.60006 4.29311 7.34595 4.93259 7.34571ZM10.2836 6.10271H12.9594V8.77846H10.2836V6.10271Z",
    stroke: "#F8F8F8",
    strokeWidth: 0.458333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreditNote);
export default __webpack_public_path__ + "static/media/icon-credit-note.6bd62aaa4a833eb89db9e7fcc4cd09ba.svg";
export { ForwardRef as ReactComponent };